import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FolderCounterUpdatedEvent } from '@hub4b/models/events/folder-counter-updated-event';
import { FolderCounterEventsService } from '@hub4b/services/events/folder-counter-events.service';

@Component({
    selector: 'app-folders-list-counter',
    templateUrl: './folders-list-counter.component.html',
    styleUrls: ['./folders-list-counter.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FoldersListCounterComponent implements OnInit {
    /**
     * Service de gestion des événements de compteur de dossiers.
     */
    private folderCounterEventsService = inject(FolderCounterEventsService);

    /**
     * Reférence à la classe gérant le changement de détection.
     */
    private cdr = inject(ChangeDetectorRef);

    /**
     * Nombre de dossiers affichés.
     */
    public displayedFoldersCount: number = 0;

    /**
     * Nombre total de dossiers respectant les filtres.
     */
    public totalFoldersCount: number = 0;

    /**
     * Constructeur.
     */
    public constructor() {
        this.subscribeToDisplayedFoldersCounterUpdatedEvent();
        this.subscribeToTotalFoldersCounterUpdatedEvent();
    }

    /**
     * Appelé à l'initialisation du composant.
     */
    ngOnInit(): void {}

    /**
     * S'abonne aux evenements de modification du compteur du nombre de dossiers affichés.
     */
    private subscribeToDisplayedFoldersCounterUpdatedEvent() {
        this.folderCounterEventsService.displayedFoldersCounterUpdated.subscribe((ev: FolderCounterUpdatedEvent) => {
            if (ev) {
                this.displayedFoldersCount = ev.count;
                this.cdr.markForCheck();
            }
        });
    }

    /**
     * S'abonne aux evenements de modification du compteur du nombre de dossiers total.
     */
    private subscribeToTotalFoldersCounterUpdatedEvent() {
        this.folderCounterEventsService.totalFoldersCounterUpdated.subscribe((ev: FolderCounterUpdatedEvent) => {
            if (ev) {
                this.totalFoldersCount = ev.count;
                this.cdr.markForCheck();
            }
        });
    }
}
